module.exports = __webpack_public_path__ + "img/min10.759cef17.png";